// Ready-to-create summary card + Created-success card.
import React from "react";
import { Check, AlertCircle, ArrowRight, ArrowLeft } from "lucide-react";
import { SEV_META, CATEGORY_LABEL } from "./aiChatConstants";

export const ChatReadyCard = ({ extracted, onCreate, onEdit }) => (
  <div
    className="rounded-lg p-4 space-y-3"
    style={{
      background: "rgba(78,208,132,0.06)",
      border: "1px solid rgba(78,208,132,0.45)",
    }}
    data-testid="ai-chat-ready-card"
  >
    <div className="flex items-center gap-2">
      <Check size={14} style={{ color: "#4ed084" }} />
      <span
        style={{
          fontFamily: "Syne, sans-serif",
          fontWeight: 600,
          fontSize: 13,
          color: "#4ed084",
          letterSpacing: "0.3px",
        }}
      >
        Ready to create — confirm below
      </span>
    </div>
    <SummaryGrid extracted={extracted} />
    <div className="flex gap-2 pt-2">
      <button
        onClick={onCreate}
        className="flex items-center gap-2 px-4 py-2 rounded transition-colors"
        style={{
          background: "rgba(78,208,132,0.20)",
          border: "1px solid #4ed084",
          color: "#4ed084",
          fontFamily: "Syne, sans-serif",
          fontWeight: 600,
          fontSize: 12,
          letterSpacing: "0.4px",
          cursor: "pointer",
        }}
        data-testid="ai-chat-create-btn"
      >
        <Check size={13} /> Create Incident
      </button>
      <button
        onClick={onEdit}
        className="flex items-center gap-2 px-4 py-2 rounded transition-colors"
        style={{
          background: "transparent",
          border: "1px solid rgba(255,255,255,0.10)",
          color: "#9ec3ec",
          fontFamily: "'DM Mono', monospace",
          fontSize: 11,
          letterSpacing: "0.4px",
          cursor: "pointer",
        }}
        data-testid="ai-chat-edit-wizard-btn"
      >
        Edit in wizard <ArrowRight size={12} />
      </button>
    </div>
  </div>
);

const SummaryGrid = ({ extracted }) => {
  const sev = extracted.severity ? SEV_META[extracted.severity] : null;
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-2" style={{ fontFamily: "'DM Mono', monospace", fontSize: 11 }}>
      <Cell label="Title" value={extracted.title} span={2} />
      <Cell label="Category" value={extracted.category ? CATEGORY_LABEL[extracted.category] || extracted.category : null} />
      <Cell
        label="Severity"
        value={
          sev ? (
            <span style={{ color: sev.color, fontWeight: 700 }}>{sev.label}</span>
          ) : null
        }
      />
      <Cell label="Affected Line" value={extracted.affected_line} />
      <Cell
        label="Units · Hours · Loss"
        value={
          (extracted.estimated_units_impact || extracted.estimated_hours_impact || extracted.estimated_eur_loss)
            ? `${extracted.estimated_units_impact || 0} · ${extracted.estimated_hours_impact || 0}h · €${extracted.estimated_eur_loss || 0}`
            : null
        }
      />
      {extracted.affected_part_numbers?.length > 0 && (
        <Cell label="Parts" span={2} value={extracted.affected_part_numbers.join(", ")} />
      )}
      {extracted.suggested_parties?.length > 0 && (
        <Cell label="Parties" span={2} value={extracted.suggested_parties.join(", ")} />
      )}
    </div>
  );
};

const Cell = ({ label, value, span = 1 }) => (
  <div className={span === 2 ? "col-span-2" : ""}>
    <div style={{ color: "#9198b0", fontSize: 9, letterSpacing: "1.2px", textTransform: "uppercase" }}>
      {label}
    </div>
    <div style={{ color: value ? "#f0f2f8" : "#5a6080", marginTop: 2 }}>
      {value || "—"}
    </div>
  </div>
);

// ---------------- Created card ----------------
export const ChatCreatedCard = ({ incident, onOpen }) => (
  <div
    className="rounded-lg p-4 flex items-center justify-between gap-3"
    style={{
      background: "rgba(78,208,132,0.08)",
      border: "1px solid rgba(78,208,132,0.45)",
    }}
    data-testid="ai-chat-created-card"
  >
    <div>
      <div className="flex items-center gap-2">
        <Check size={14} style={{ color: "#4ed084" }} />
        <span
          style={{
            fontFamily: "Syne, sans-serif",
            fontWeight: 700,
            fontSize: 14,
            color: "#4ed084",
            letterSpacing: "0.3px",
          }}
        >
          Incident created
        </span>
      </div>
      <div
        style={{
          fontFamily: "'DM Mono', monospace",
          fontSize: 12,
          color: "#cfd1d8",
          marginTop: 4,
        }}
      >
        <span style={{ color: "#9ec3ec" }}>{incident.id}</span>
        {" · "}
        {incident.title}
      </div>
    </div>
    <button
      onClick={onOpen}
      className="flex items-center gap-2 px-3 py-2 rounded"
      style={{
        background: "#185FA5",
        border: "1px solid #185FA5",
        color: "#fff",
        fontFamily: "Syne, sans-serif",
        fontWeight: 600,
        fontSize: 12,
        cursor: "pointer",
        whiteSpace: "nowrap",
      }}
      data-testid="ai-chat-open-incident"
    >
      Open Incident <ArrowRight size={12} />
    </button>
  </div>
);

